import React, {Component} from 'react';
import {connect} from 'react-redux';

import './RoundSelector.css';
import {intervalDataChanged, selectRound, showIntervalChangeWarning } from '../../actions/CompetitionActions';
import { Trans} from 'react-i18next';

class RoundSelector extends Component {

    constructor(props) {

        super(props);
        this.state = {}
    }

    selectChanged = (e) => {
        this.selectRound(parseInt(e.target.value));
    }

    selectRound = (idRound) => {

        const {currentRound, intervalChangeDetect} = this.props.competition;
        if (intervalChangeDetect && intervalChangeDetect.hasIntervalDataChanged) {
            this.props.dispatch(showIntervalChangeWarning(
                idRound,
                this.props.dispatch
            ));
            this.render();
            return false;
        } else {
            const newRound = this.props.competition.rounds.find(r => r.id === idRound);
            this.props.dispatch(selectRound(
                newRound,
                this.props.dispatch
            ));
            this.props.dispatch(intervalDataChanged(
                false,
                this.props.dispatch
            ));
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.competition && nextProps.competition.intervalChangeDetect
            && nextProps.competition.intervalChangeDetect.proceedWithoutSavingInterval
            && nextProps.competition.intervalChangeDetect.proceedWithoutSavingInterval
                !== this.props.competition.intervalChangeDetect.proceedWithoutSavingInterval) {
            const idRound = nextProps.competition.intervalChangeDetect.proceedWithoutSavingInterval;
            const newRound = this.props.competition.rounds.find(r => r.id === idRound);
            this.props.dispatch(selectRound(
                newRound,
                this.props.dispatch
            ));
        }
    }

    render() {

        const {rounds, currentRound, data} = this.props.competition;
        if (!currentRound)
            return null;

        const availableRounds = rounds.map(r => {
            return (<div
                key={r.id}
                // style={{backgroundColor: data ? data.secondaryColor : ''}}
                className={`roun-nums ${currentRound && r.id === currentRound.id ? 'sel-round' : ''}`}
                style={{
                    backgroundColor: data && currentRound && r.id === currentRound.id ? data.primaryColor : '',
                    color: data && currentRound && r.id === currentRound.id ? data.secondaryColor : '',
                }}
                onClick={() => this.selectRound(r.id)}>
                <div>{r.name}</div>
            </div>);
        })
        const availableRoundsSelect = rounds.map(r => {
        return (<option key={r.id} value={r.id} defaultValue={r.id === currentRound.id?true:false} >{r.name}</option>);

        })
        return rounds ? (
            rounds.length <= 1 ? null : (
            <div
                 className='round-selector'>
                {/* <div
                     className={`legend ${currentRound && 1 === currentRound.id ? 'first' : ''}`}>
                        <Trans i18nKey="select_a_round" />
                </div> */}
                {/* <div className='round-select-desktop'>
                    {availableRounds}
                </div>*/}
                <div className='legend'>
                  <div className={`circle ${currentRound && currentRound.voteOpen ? 'green-fill' : 'red-fill'}`}></div>
                  <span>{currentRound && currentRound.voteOpen ? 'OPEN' : 'CLOSED' }</span>
                </div>
                <select className='round-select-desktop' value={currentRound.id} onChange={this.selectChanged}>
                    {availableRoundsSelect}
                </select>
                <select className='form-control round-select-mobile' value={currentRound.id} onChange={this.selectChanged}>
                    {availableRoundsSelect}
                </select>
            </div>
            )
        ) : null;
    }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const mapStateToProps = (state, ownProps) => {

    const things = state.default;
    return {
        ...ownProps,
        competition: things.competition,
        locale: things.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch,

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RoundSelector);
